import React from 'react';
import { Award, Users, Clock, ThumbsUp } from 'lucide-react';

export const AboutSection = () => {
  const stats = [
    {
      icon: Award,
      value: '15+',
      label: 'Années d\'expérience'
    },
    {
      icon: Users,
      value: '500+',
      label: 'Clients satisfaits'
    },
    {
      icon: Clock,
      value: '7j/7',
      label: 'Service disponible'
    },
    {
      icon: ThumbsUp,
      value: '100%',
      label: 'Satisfaction client'
    }
  ];

  return (
    <section id="apropos" className="py-20 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-blue-50 to-transparent opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              À propos de <span className="text-blue-600">RCCB</span>
            </h2>
            
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>
                <strong className="text-blue-600">RCCB</strong> est votre partenaire de confiance pour tous vos travaux de second œuvre dans le bâtiment. 
                Forte d'une expérience solide dans le domaine, notre entreprise s'est spécialisée dans la peinture, 
                la plâtrerie, la plomberie, les sols, le carrelage ainsi que les travaux de bricolage.
              </p>
              
              <p>
                Notre équipe de professionnels qualifiés met son savoir-faire au service de vos projets, 
                qu'ils soient résidentiels ou commerciaux. Nous nous engageons à vous fournir des prestations 
                de qualité supérieure, dans le respect des délais et de votre budget.
              </p>
              
              <p>
                La satisfaction de nos clients est notre priorité absolue. C'est pourquoi nous privilégions 
                l'écoute, le conseil personnalisé et un suivi rigoureux de chaque chantier, du devis à la réalisation finale.
              </p>
            </div>

            {/* Values */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-xl">
                <h4 className="font-bold text-blue-900 mb-1">Qualité</h4>
                <p className="text-sm text-gray-700">Travail soigné et durable</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-xl">
                <h4 className="font-bold text-blue-900 mb-1">Réactivité</h4>
                <p className="text-sm text-gray-700">Intervention rapide</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-xl">
                <h4 className="font-bold text-blue-900 mb-1">Expertise</h4>
                <p className="text-sm text-gray-700">Équipe qualifiée</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-xl">
                <h4 className="font-bold text-blue-900 mb-1">Transparence</h4>
                <p className="text-sm text-gray-700">Devis détaillé</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/35300835/pexels-photo-35300835.jpeg?w=800&q=80"
                alt="Équipe RCCB"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Stats Overlay */}
            <div className="absolute -bottom-8 -left-8 right-8 bg-white rounded-2xl shadow-2xl p-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="flex justify-center mb-2">
                      <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                        <stat.icon className="text-blue-600" size={24} />
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
                    <div className="text-xs text-gray-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
